import React from 'react';
const backEndDataContext = React.createContext();
export const BackendDataProvider = backEndDataContext.Provider;
export default backEndDataContext;